import { DEVICE } from '@/shared/config';

/**
 * Recognises a device as an ICOR unit. Compares the device's model against the ICOR device constant.
 *
 * @param device - Device whose model is inspected.
 * @returns True when the device model is ICOR.
 */
const checkIcorDevice = (device?: { model: string }) => device?.model === DEVICE.ICOR;

export { checkIcorDevice };
